import { render, staticRenderFns } from "./InventoryHome.vue?vue&type=template&id=ab343a5c&"
import script from "./InventoryHome.vue?vue&type=script&lang=ts&"
export * from "./InventoryHome.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryHome.vue?vue&type=style&index=0&id=ab343a5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports